import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'Services', href: '#services' },
  { name: 'Portfolio', href: '#portfolio' },
  { name: 'About', href: '#about' },
  { name: 'Contact', href: '#contact' }];


  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`
      }>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <a href="#home" className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_brandmitra-digital/artifacts/u617uzad_BM%20New%20logo%20png.png" 
                alt="BrandMitraa Logo" 
                className="h-20 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) =>
            <button
              key={link.name}
              onClick={() => scrollToSection(link.href)}
              className="text-slate-700 hover:text-orange-600 font-medium transition-colors">

                {link.name}
              </button>
            )}
            <Button
              onClick={() => scrollToSection('#contact')}
              className="bg-orange-600 hover:bg-orange-700 text-white">

              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-slate-900"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>

            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden bg-white border-t border-slate-200 py-4">
            {navLinks.map((link) =>
          <button
            key={link.name}
            onClick={() => scrollToSection(link.href)}
            className="block w-full text-left px-4 py-3 text-slate-700 hover:bg-slate-50 hover:text-orange-600 transition-colors">

                {link.name}
              </button>
          )}
            <div className="px-4 mt-2">
              <Button
              onClick={() => scrollToSection('#contact')}
              className="w-full bg-orange-600 hover:bg-orange-700 text-white">

                Get Started
              </Button>
            </div>
          </div>
        }
      </div>
    </header>);

};

export default Header;